import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/TaskTable";
import TaskTable from "../components/TaskTable";
import TaskDrawer from "../components/TaskDrawer";
import { useAuth } from "../lib/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

const SECTIONS = [
  ["due_today", "Due Today"], ["overdue", "Overdue"], ["due_tomorrow", "Due Tomorrow"],
  ["high_priority", "High Priority"], ["waiting_on_me", "Waiting on Me"], ["waiting_on_others", "Waiting on Others"],
  ["assigned_by_me", "Assigned by Me"], ["following", "Following"], ["pending_my_approval", "Pending My Approval"],
  ["recently_completed", "Recently Completed"], ["my_tasks", "All My Tasks"],
];

export default function MyWork() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [tab, setTab] = useState("due_today");
  const load = () => api.get("/my-work").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  if (!data) return <div className="p-6 text-slate-400">Loading…</div>;

  return (
    <div className="p-6">
      <PageHeader title="My Work" subtitle={`Welcome back, ${user?.full_name}`} />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-5">
        {[["due_today","Due Today","#CA8A04"],["overdue","Overdue","#C2410C"],["high_priority","High Priority","#DC2626"],["waiting_on_me","Waiting on Me","#2563EB"],["pending_my_approval","My Approvals","#1E40AF"]].map(([k,l,c]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`mywork-kpi-${k}`} className="kpi-hover bg-white border rounded-xl p-4 text-left">
            <div className="text-2xl font-bold font-mono" style={{ color: c }}>{data[k]?.length || 0}</div>
            <div className="text-xs text-slate-500 mt-0.5">{l}</div>
          </button>
        ))}
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap h-auto justify-start mb-3">
          {SECTIONS.map(([k, l]) => (
            <TabsTrigger key={k} value={k} data-testid={`mywork-tab-${k}`}>{l} ({data[k]?.length || 0})</TabsTrigger>
          ))}
        </TabsList>
        {SECTIONS.map(([k]) => (
          <TabsContent key={k} value={k}><TaskTable tasks={data[k]} onOpen={setOpenId} compact /></TabsContent>
        ))}
      </Tabs>
      {openId && <TaskDrawer taskId={openId} onClose={() => setOpenId(null)} onChanged={load} />}
    </div>
  );
}
